module.exports = __webpack_public_path__ + "static/img/header-img_02.19daf23b.jpg";